import { loadStripe, type Stripe } from "@stripe/stripe-js";

// A single Stripe.js instance is loaded once per app load and reused everywhere.
// loadStripe returns a promise, so hoisting it here (module level) avoids
// re-downloading Stripe.js each time a card form mounts.
const publishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

let stripePromise: Promise<Stripe | null> | null = null;

export function getStripe(): Promise<Stripe | null> {
  if (!publishableKey) {
    // Surfaced during development so a missing env var is obvious rather than a
    // silently blank card widget.
    console.error(
      "VITE_STRIPE_PUBLISHABLE_KEY is not set — the card form cannot load.",
    );
    return Promise.resolve(null);
  }
  stripePromise ??= loadStripe(publishableKey);
  return stripePromise;
}
